import { render, staticRenderFns } from "./MatchFightModal.vue?vue&type=template&id=152c2777&scoped=true&"
import script from "./MatchFightModal.vue?vue&type=script&lang=js&"
export * from "./MatchFightModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c2777",
  null
  
)

export default component.exports